// Older builds registered a service worker. Unregister it so those clients drop
// the worker. public/ does not ship service-worker.js.
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    });
  }
}
